import { useAnalytics, useMetrics, useObservabilityConfig, useProject, useReports } from "@sail/observability";
import { useCallback } from "react";
import logHttp from "../logHttp";
export default function useLogFetch(observabilityConfig) {
    var _useObservabilityConfig;
    const project = useProject();
    const service = (_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service;
    const errors = useReports();
    const metrics = useMetrics();
    const analytics = useAnalytics();
    const { expectedApiErrors, mutedApiErrors } = observabilityConfig;
    return useCallback((res, duration, settings)=>{
        const { headers, status, statusText, url } = res;
        const { expectedErrors, mutedErrors } = settings;
        const computedExpectedErrors = expectedApiErrors.concat(expectedErrors !== null && expectedErrors !== void 0 ? expectedErrors : []);
        const computedMutedErrors = mutedApiErrors.concat(mutedErrors !== null && mutedErrors !== void 0 ? mutedErrors : []);
        if (computedExpectedErrors.includes(status)) {
            return;
        }
        let errorSource = '<unknown>';
        if (status < 100) {
            errorSource = 'network';
        }
        if (status >= 400 && status < 500) {
            errorSource = 'client';
        }
        if (status >= 500 && status < 600) {
            errorSource = 'server';
        }
        const observabilityFns = {
            errors,
            metrics,
            analytics
        };
        const mute = !!computedMutedErrors.includes(status);
        var _headers_get;
        logHttp('Fetch', observabilityFns, {
            // Ownership information:
            service: service !== null && service !== void 0 ? service : '<unknown>',
            project: project !== null && project !== void 0 ? project : '<unknown>',
            component: '<unknown>',
            // Error information:
            errorCode: `HTTP ${status}`,
            errorMessage: statusText,
            errorPath: '',
            errorExpected: false,
            errorMuted: mute,
            errorSource,
            // Operation information:
            operationTag: 'http',
            operationName: url,
            operationDeduplicate: false,
            operationPrefetch: false,
            operationPrefetchHit: false,
            // Network information:
            networkDuration: duration !== null && duration !== void 0 ? duration : null,
            networkStatus: status !== null && status !== void 0 ? status : null,
            networkActionId: null,
            networkRequestId: (_headers_get = headers.get('Request-Id')) !== null && _headers_get !== void 0 ? _headers_get : null,
            networkTraceId: null
        });
    }, [
        expectedApiErrors,
        mutedApiErrors,
        errors,
        metrics,
        analytics,
        service,
        project
    ]);
}

//# sourceMappingURL=useLogFetch.js.map